/**
 * Deterministic canonical JSON serialization: object keys are sorted
 * recursively so the same logical payload always hashes/signs identically
 * regardless of property insertion order.
 */
export function canonicalize(value: unknown): string {
  return JSON.stringify(sortValue(value));
}

function sortValue(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.map(sortValue);
  }
  if (value !== null && typeof value === 'object') {
    const entries = Object.entries(value as Record<string, unknown>)
      .sort(([a], [b]) => (a < b ? -1 : a > b ? 1 : 0))
      .map(([key, val]) => [key, sortValue(val)] as const);
    return Object.fromEntries(entries);
  }
  return value;
}
